import React from 'react';

const CustomCheckboxUncheckedSVG = ({ fill }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" stroke={fill} />
    </svg>
  );
};

export default CustomCheckboxUncheckedSVG;
